import { DataManagementConfig } from '@shared/components/data-management';
import { DomainTableData, DomainFormData } from '../types';
import { AddDomainDialog } from '../components';
import {
  useDomainsTableData,
  useCreateDomain,
  useUpdateDomain,
  useDeleteDomain,
} from '../hooks/useDomains';

export const createDomainsConfig = (
  tenantId: string,
  navigate?: (path: string) => void
): DataManagementConfig<DomainTableData, DomainFormData, DomainFormData> => ({
  hooks: {
    useQuery: () => useDomainsTableData(tenantId),
    useCreate: () => useCreateDomain(tenantId),
    useUpdate: () => useUpdateDomain(tenantId),
    useDelete: () => useDeleteDomain(tenantId),
  },

  table: {
    title: 'Institutes',
    columns: [
      { key: 'name', label: 'Name' },
      { key: 'code', label: 'Code', render: (value) => value || null },
      { key: 'description', label: 'Description', render: (value) => value || null },
      {
        key: 'createdAt',
        label: 'Created',
        render: (value) => (value ? new Date(value).toLocaleDateString() : null),
      },
    ],
    emptyMessage: 'No institutes found for this university',
    errorMessage: 'Failed to load institutes. Please try refreshing the page.',
  },

  actions: {
    create: {
      label: 'Add Institute',
      dialog: AddDomainDialog,
    },
    edit: {
      label: 'Edit',
    },
    delete: {
      label: 'Delete',
      confirmTitle: 'Delete Institute',
      confirmMessage: (domain) =>
        `Are you sure you want to delete "${domain.name}"? This action cannot be undone and may affect associated subjects and courses.`,
    },
  },

  features: {
    search: true,
    pagination: true,
    onRowClick: navigate
      ? (domain) => {
          navigate(`/app/manage/universities/${tenantId}/institutes/${domain.id}`);
        }
      : undefined,
  },
});
